import React, { forwardRef } from 'react';
export var MoreMenuTabSentinel = forwardRef(function (props, ref) {
    var onFocus = props.onFocus, id = props.id;
    return (React.createElement("div", { ref: ref, "aria-hidden": true, style: { position: 'absolute', top: 0, left: 0, height: 0, width: 0 }, tabIndex: -1, "data-tab-sentinel": id, onFocus: onFocus }));
});
MoreMenuTabSentinel.displayName = 'MoreMenuTabSentinel';
